import { DatePipe, TitleCasePipe, WeekDay } from "@angular/common";
import { Injectable } from "@angular/core";
import { EntityExData, EnumHelper, HorizontalListData, HorizontalListFactory } from "common";

@Injectable()
export class EntityProfileAdapter {
  constructor(
    private readonly datePipe: DatePipe,
    private readonly titleCasePipe: TitleCasePipe,
  ) { }

  adaptStatusListData = (entity: EntityExData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Status',
        displayedValue: this.titleCasePipe.transform(entity?.status)
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Entity number',
        displayedValue: entity?.entityNumber
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Created on',
        displayedValue: this.getCreatedOnValue(entity),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Created by',
        displayedValue: entity?.createdBy
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Updated on',
        displayedValue: this.formatDate(entity?.updatedOn) || '-'
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Updated by',
        displayedValue: entity?.updatedBy
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Active',
        displayedValue: entity?.active ? "Yes" : "No"
      }),
    ]
  }

  adaptBrokerListData = (entity: EntityExData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Company',
        displayedValue: entity?.brokerName
      }),
    ]
  }

  private getCreatedOnValue(entity: EntityExData): string {
    const weekDay = entity.createdOn
      ? EnumHelper.getNameFromValue(WeekDay, new Date(entity.createdOn).getDay())
      : '';
    return `${this.formatDate(entity?.createdOn)} - ${weekDay}`;
  }

  private formatDate(value: Date): string {
    return this.datePipe.transform(value);
  }
}